import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["height"];
import React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
var margins = ["mt-0", "mt-1", "mt-2", "mt-3", "mt-4", "mt-5", "mt-6", "mt-7", "mt-8", "mt-9", "mt-10", "mt-11", "mt-12", "mt-14", "mt-16", "mt-20", "mt-24", "mt-28", "mt-32"]; // todo add responsive spacer classes

export var Spacer = props => {
  var {
    height = 5
  } = props,
      rest = _objectWithoutPropertiesLoose(props, _excluded);

  return /*#__PURE__*/_jsx("div", _extends({
    className: margins[height]
  }, rest));
};
//# sourceMappingURL=spacer.js.map